// Where to send the patient back to after a successful payment.
// Call packages → the doctors / pharmacists list they were browsing.
// Physio & psychology → straight into the booking form (they still need to
// fill in their appointment info).

const ORIGIN_KEY = 'tababa_call_origin';
const DEFAULT_DOCTORS = '/doctors?category=doctors';
// Never bounce the user back to a packages / checkout screen.
const PACKAGE_PATHS = ['/subscriptions', '/physio', '/psychology', '/payments'];

export const isSafePath = (p) =>
  typeof p === 'string' && p.startsWith('/') && !p.startsWith('//') && !p.includes('://');

const isPackagePath = (p) => PACKAGE_PATHS.some((x) => p === x || p.startsWith(`${x}/`) || p.startsWith(`${x}?`));

/** Remember the list the patient was on before heading to checkout. */
export const rememberCallOrigin = (path) => {
  try {
    const p = path || (window.location.pathname + (window.location.search || ''));
    if (isSafePath(p) && !isPackagePath(p)) sessionStorage.setItem(ORIGIN_KEY, p);
  } catch { /* storage blocked */ }
};

export const resolveReturnTo = ({ packageKind, packageId, explicit }) => {
  if (packageKind === 'physio' && packageId) return `/physio/book/${packageId}`;
  if (packageKind === 'psychology') return '/psychology/doctors';

  if (isSafePath(explicit) && !isPackagePath(explicit)) return explicit;
  try {
    const stored = sessionStorage.getItem(ORIGIN_KEY);
    if (isSafePath(stored) && !isPackagePath(stored)) return stored;
  } catch { /* storage blocked */ }
  const here = window.location.pathname + (window.location.search || '');
  if (isSafePath(here) && !isPackagePath(here)) return here;
  return DEFAULT_DOCTORS;
};

export const clearCallOrigin = () => {
  try { sessionStorage.removeItem(ORIGIN_KEY); } catch { /* noop */ }
};
